export const termsStore: string[] = [];


let termObservers: Function[] = [];

export function subscribeToTermStore(callBack: Function) {
  termObservers.push(callBack);
}

export function addTermIntoStore( term: string ) {
  termsStore.push(term);
  termObservers.forEach(observer => observer(termsStore));
}   

export function unsubscribeFromTermStore(callBack: Function) {
  termObservers = termObservers.filter(observer => observer !== callBack);
}